import { ReactNode } from "react";
import { Toast, toast } from "react-hot-toast";

export default function makeToast(
  children: ReactNode,
  opts?:
    | Partial<
        Pick<
          Toast,
          | "id"
          | "icon"
          | "duration"
          | "ariaProps"
          | "className"
          | "style"
          | "position"
          | "iconTheme"
        >
      >
    | undefined,
): string {
  return toast.custom((t) => <div>{children}</div>, opts);
}
